module.exports = __webpack_public_path__ + "static/media/cow.d3640418.png";